import { VFC } from 'react'
import { RequestBoxCompany } from 'src/models/RequestBox'
import { Counter } from 'src/models/Room'
import { CounterRequestBox } from './CounterRequestBox'
import { MyRequestBox } from './MyRequestBox'

export const RequestBoxComponent: VFC<{
  requestBox: RequestBoxCompany
  sender: Counter
  showProfile: (userId: number) => void
}> = ({ requestBox, sender, showProfile }) => {
  if (!requestBox.requestReason || requestBox.requestReason === 'greet')
    return <></>
  const isMyRequest = requestBox.companyId !== sender?.id
  return (
    <>
      {isMyRequest ? (
        <MyRequestBox requestBox={requestBox} />
      ) : (
        <CounterRequestBox
          sender={sender}
          requestBox={requestBox}
          showProfile={showProfile}
        />
      )}
    </>
  )
}
